import { localStorageSafe } from '../utils/index'

export const setUserAndToken = (username, token) => {
  if (localStorageSafe) {
    localStorage.setItem('username', username)
    localStorage.setItem('run-24-hrs-token', token)
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/api/utils.js